<template lang="html">
    <div class="client-edit">
        <top-nav></top-nav>

        <div class="page-title">
            <div class="container">
                <span class="icon icon-location"></span>
                <h1>{{pageTitleText}}</h1>
                <span v-if="uid" class="icon-bin" @click="openDialog()"></span>
            </div>
        </div>

        <el-dialog v-if="uid" :visible.sync="dialog" :title="getText('site_dialog_title')" center>
            <span>{{getText('site_dialog_text')}}<strong>{{clientSite.val}}</strong> ?</span>
            <span slot="footer" class="dialog-footer">
                <div class="dialogButtons">
                    <el-button class="cancel whiteButton" @click="closeDialog()">{{getText('cancel_button')}}</el-button>
                    <el-button v-loading="loadings.delete" :disabled="loadings.delete" class="save greenButton" @click="deleteSite">{{getText('dialog_confirm_archive_button')}}</el-button>
                </div>
            </span>
        </el-dialog>

        <div class="viveco-footer-background">
            <div class="client-edit-form container">

                <el-row :gutter="24">
                    <el-form class="siteForm" label-position="top" ref="auditForm" :model="audit" :rules="rules">
                        <el-col :span="24">
                            <div class="category">{{getText('site_form_category_audit')}}</div>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="getText('site_form_audit')" prop="name" >
                                <el-input
                                    v-model="audit.name"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :label="getText('site_form_start')" prop="start">
                                <el-date-picker
                                  v-model="audit.start"
                                  type="date"
                                  :placeholder="getText('site_form_start_placeholder')">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :label="getText('site_form_end')" prop="end">
                                <el-date-picker
                                  v-model="audit.end"
                                  type="date"
                                  :placeholder="getText('site_form_end_placeholder')">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <div class="category">{{ getText('site_form_category_site') }}</div>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item :label="getText('site_form_location')" prop="address" >
                                <el-input
                                    v-model="audit.address"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :label="getText('site_form_name')" prop="site_name" >
                                <el-input
                                    v-model="audit.site_name"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :label="getText('site_form_naf_code')" prop="naf_code" >
                                <el-select class="naf-code-selector" popper-class="naf-code-popper" v-model="audit.naf_code" placeholder="" filterable>
                                    <el-option-group
                                      v-for="group in Object.keys(codeNafsAvailable)"
                                      :key="group"
                                      :label="group">
                                      <el-option
                                        v-for="item in codeNafsAvailable[group]"
                                        :key="item"
                                        :label="item"
                                        :value="item">
                                      </el-option>
                                    </el-option-group>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <div class="category">{{ getText('site_form_category_energy') }}</div>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :label="getText('site_form_price')" prop="electricity_price" >
                                <el-input
                                    type="number"
                                    v-model="audit.electricity_price"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :label="getText('site_form_operational_mod')" prop="operational_mod" >
                                <el-select class="operational-mod-selector" v-model="audit.operational_mod" placeholder="" filterable>
                                    <el-option v-for="item in operationalModAvailable"
                                        :key="item"
                                        :label="item"
                                        :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :label="getText('site_form_yearly_consumption')" prop="yearly_consumption" >
                                <el-input
                                    type="number"
                                    v-model="audit.yearly_consumption"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :label="getText('site_form_cee_price')" prop="cee_price" >
                                <el-input
                                    type="number"
                                    v-model="audit.cee_price"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <div class="category">{{ getText('site_form_category_contacts') }}</div>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :label="getText('site_form_contact')" prop="contact_client" >
                                <el-input
                                    v-model="audit.contact_client"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :label="getText('site_form_client_name')" prop="client_name" >
                                <el-input
                                    v-model="audit.client_name"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :label="getText('site_form_edf_delegate_1')" prop="delegate1">
                                <div class="delegate-section">
                                    <label>{{ getText('site_form_edf_delegate_name_label') }}</label>
                                    <el-input
                                        v-model="audit.edf_delegates[0].name"
                                    ></el-input>
                                    <label>{{ getText('site_form_edf_delegate_job_label') }}</label>
                                    <el-input
                                        v-model="audit.edf_delegates[0].job"
                                    ></el-input>
                                    <label>{{ getText('site_form_edf_delegate_phone_label') }}</label>
                                    <el-input
                                        v-model="audit.edf_delegates[0].phone"
                                    ></el-input>
                                    <label>{{ getText('site_form_edf_delegate_mail_label') }}</label>
                                    <el-input
                                        v-model="audit.edf_delegates[0].mail"
                                    ></el-input>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :label="getText('site_form_edf_delegate_2')" prop="delegate2">
                                <div class="delegate-section">
                                    <label>{{ getText('site_form_edf_delegate_name_label') }}</label>
                                    <el-input
                                        v-model="audit.edf_delegates[1].name"
                                    ></el-input>
                                    <label>{{ getText('site_form_edf_delegate_job_label') }}</label>
                                    <el-input
                                        v-model="audit.edf_delegates[1].job"
                                    ></el-input>
                                    <label>{{ getText('site_form_edf_delegate_phone_label') }}</label>
                                    <el-input
                                        v-model="audit.edf_delegates[1].phone"
                                    ></el-input>
                                    <label>{{ getText('site_form_edf_delegate_mail_label') }}</label>
                                    <el-input
                                        v-model="audit.edf_delegates[1].mail"
                                    ></el-input>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <div class="category">{{ getText('site_form_category_misc') }}</div>
                        </el-col>

                        <el-col :span="24">
                            <el-form-item :label="getText('site_form_comment')" prop="interlocuteur1" >
                                <el-input
                                    v-model="audit.comment"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <div class="category">{{ getText('site_form_category_picture') }}</div>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :label="getText('site_form_picture')" prop="site_image" >
                                <el-upload
                                    class="avatar-uploader"
                                    action=""
                                    ref="upload"
                                    :show-file-list="false"
                                    :on-change="handleAvatarChange"
                                    :auto-upload="false"
                                >
                                    <img v-if="imageUrl" :src="imageUrl" class="avatar">
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                                <div v-if="showImgError" class="image-error">{{ getText('site_form_picture_error') }}</div>
                            </el-form-item>
                        </el-col>
                    </el-form>
                </el-row>
                <div class="cta-save">
                    <el-row :gutter="24">
                        <el-col :span="6">
                            <cancel-back :txt="getText('cancel_button')"></cancel-back>
                        </el-col>
                        <el-col :span="6" :offset="12">
                            <el-button
                                v-loading="loadings.save"
                                class="greenButton"
                                :style="{ background: getColor() }"
                                :disabled="!checkSiteIntegrity() || loadings.save"
                                @click="saveSite()">{{getText('save_button')}}
                            </el-button>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>

        <page-footer></page-footer>
    </div>
</template>

<script>
import topNav from '../ui/top-nav.vue';
import pageFooter from '../ui/page-footer.vue';
import cancelBack from '../ui/cancel-back.vue';
import {mapGetters} from 'vuex';
import moment from 'moment';

export default {
    data () {
        return {
            operationalModAvailable: ['1x8h', '2x8h et 5j/7 ou 6j/7', '3x8h avec arrêt le weekend', '3x8h sans arrêt le weekend'],
            codeNafsAvailable: [],
            loadings: {
                save: false,
                delete: false
            },
            dialog: false,
            valid: false,
            lang: this.getLangage,
            uid: '',
            clientSite: {
                val: '',
            },
            imageUrl: '',
            showImgError: false,
            audit: {
                name: '',
                site_name: '',
                address: '',
                yearly_consumption: 0,
                cee_price:'',
                electricity_price:'',
                contact_client: '',
                client_name: '',
                comment: '',
                start: null,
                end: null,
                operational_mod: null,
                site_image: null,
                naf_code: null,
                edf_delegates: [{}, {}],
            },
            rules: {
                name: [
                    { required: true, message: this.$store.getters.getText('site_form_audit_error_message'), trigger: 'blur'}
                ],
                site_name: [
                    { required: true, message: this.$store.getters.getText('site_form_name_error_message'), trigger: 'blur'}
                ],
                start: [
                    { required: true, message: this.$store.getters.getText('site_form_start_error_message')}
                ],
                operational_mod: [
                    { required: true, message: this.$store.getters.getText('site_form_operational_mod_error_message')}
                ],
                end: [
                    { required: true, message: this.$store.getters.getText('site_form_end_error_message')}
                ],
                naf_code: [
                    { required: true, message: this.$store.getters.getText('site_form_naf_code_error_message')}
                ],
                electricity_price: [
                    { required: true, message: this.$store.getters.getText('site_form_price_error_message'), trigger: 'blur'}
                ],
                cee_price: [
                    { required: true, message: this.$store.getters.getText('site_form_price_error_message'), trigger: 'blur'}
                ],
                address: [
                    { required: true, message: this.$store.getters.getText('site_form_location_error_message'), trigger: 'blur'}
                ],
                client_name: [
                    { required: true, message: this.$store.getters.getText('site_form_client_name_error_message'), trigger: 'blur'}
                ],
            }
        };
    },
    computed: {
        ...mapGetters([
            'getText',
            'getLangage',
            'factoriesByUid',
            'nafs'
        ]),
        getAudit() {
            let audit = this.factoriesByUid(this.$route.params.uid);
            if (audit){
                if (Object.keys(audit.edf_delegates).length === 0) {
                    audit.edf_delegates = [
                        {name: '', job: '', phone: '', mail: ''},
                        {name: '', job: '', phone: '', mail: ''}
                    ]
                }
                return audit;
            }
            return {
                name: ''
            };
        },
        pageTitleText() {
            let defaultTitle = this.getText('site_default_title');
            if (this.uid.length) {
                defaultTitle = this.getText('site_default_update_title');
            }
            return this.audit.name.length ? this.audit.name : defaultTitle;
        },
    },
    mounted() {
        this.codeNafsAvailable = this.nafs[0].front_side;
        let factory = this.factoriesByUid(this.$route.params.uid);
        if (factory){
            this.clientSite.val = factory.name;
            this.uid = factory.uid;
        }
        if (this.$route.params.uid && this.audit.uid == null) {
            this.audit = JSON.parse(JSON.stringify(this.getAudit));
            this.imageUrl = this.audit.site_image;
        }
    },
    methods: {
        imageSizeIsValid (img){
            return img.width >= 1000 && img.height >= 750;
        },
        handleAvatarChange(file) {
            let self = this;
            let reader = new FileReader();
            reader.onload = function() {
                let img = new Image;
                self.showImgError = false;
                img.onload = function(){
                    if(!self.imageSizeIsValid(img)) {
                        self.showImgError = true;
                        return;
                    }
                    self.imageUrl = URL.createObjectURL(file.raw);
                }
                img.src = reader.result;
            };
            reader.readAsDataURL(file.raw);
        },
        changeRulesMessage() {
            this.rules.name[0].message = this.getText('site_form_audit_error_message');
            this.rules.site_name[0].message = this.getText('site_form_name_error_message');
            this.rules.address[0].message = this.getText('site_form_location_error_message');
            this.rules.electricity_price[0].message = this.getText('site_form_price_error_message');
            this.rules.client_name[0].message = this.getText('site_form_client_name_error_message');
            this.rules.start[0].message = this.getText('site_form_start_error_message');
            this.rules.operational_mod[0].message = this.getText('site_form_operational_mod_error_message');
            this.rules.end[0].message = this.getText('site_form_end_error_message');
            this.rules.naf_code[0].message = this.getText('site_form_naf_code_error_message');
            this.rules.cee_price[0].message = this.getText('site_form_price_error_message');
        },
        checkSiteIntegrity() {
            if (this.$refs.auditForm) {
                this.$refs.auditForm.validate((valid) => {
                    if (valid) {
                        this.valid = true;
                    }
                    else {
                        this.valid = false;
                    }
                });
            }
            return this.valid;
        },
        getColor() {
            if (this.getLangage != this.lang) {
                this.lang = this.getLangage;
                this.changeRulesMessage();
            }
            if (!this.checkSiteIntegrity()) {
                return '#dee873 !important';
            }
            return '#c4d600 !important';
        },
        saveSite() {
            let method = 'createItem';
            let item = this.audit;
            delete item.site_image;
            item.start = moment(this.audit.start).format('YYYY-MM-DD');
            item.end = moment(this.audit.end).format('YYYY-MM-DD');
            let newSite = {
                item: item,
                model: 'factories'
            };
            this.loadings.save = true;
            if (this.uid) {
                method = 'updateItem';
            }
            else {
                newSite.url = this.$store.state.api.meta.listModels.factories.url;
            }

            this.$store.dispatch(method, newSite).then(async (res) => {
                if (this.imageUrl) {
                    let formData = new FormData()
                    if (this.$refs.upload.$data.uploadFiles[0]) {
                        formData.append('site_image', this.$refs.upload.$data.uploadFiles[0].raw)
                    }
                    return await this.$store.axios.patch(
                        res.url,
                        formData,
                        {headers: {
                            'Content-Type': 'multipart/form-data',
                            ...this.$store.getters.getScope
                        }}
                    ).then(res => {
                        this.$store.dispatch('fetchModelByName', 'factories')
                        return res
                    }).catch((error) => {
                        throw error
                    })
                } else {
                    return res;
                }
            }).then(res => {
                if (method === 'updateItem') {
                    this.$notify({
                        title: this.getText('notify_success_title'),
                        message: this.getText('notify_site_update_successful'),
                        type: 'success'
                    });
                }
                else {
                    this.$notify({
                        title: this.getText('notify_success_title'),
                        message: this.getText('notify_site_create_successful'),
                        type: 'success'
                    });
                }
                this.loadings.save = false;
                this.$router.push({ name: 'moteurs', params: { siteid: res.uid }});
            }).catch(err => {
                this.$notify({
                    title: this.getText('notify_failed_title'),
                    type: 'error'
                });
                this.loadings.save = false;
            })
        },
        deleteSite() {
            this.loadings.delete = true;
            this.$store.dispatch('patchItem', {
                item : {
                    url: this.audit.url,
                    archived: true
                },
                model: 'factories',
            }).then(response => {
                this.$notify({
                    title: this.getText('notify_success_title'),
                    message: this.getText('notify_site_delete_successful'),
                    type: 'success'
                });
                this.loadings.delete = false;
                this.closeDialog();
                this.$router.push({ name: 'sites' });
            }).catch(() => {
                this.$notify({
                    title: this.getText('notify_failed_title'),
                    type: 'error'
                });
                if (del) {
                    this.closeDialog();
                }
                this.loadings.delete = false;
            })
        },
        openDialog() {
            this.dialog = true;
        },
        closeDialog() {
            this.dialog = false;
        },
    },
    components: {
        topNav,
        pageFooter,
        cancelBack
    },
};
</script>

<style lang="less">
@import '../../less/variables';

.el-dialog__header {
    display: flex;
    align-items: center;
    width: 90%;
    padding-left: 40px;
    flex-direction: row;
    margin: auto;
    justify-content: space-between;
    .el-dialog__headerbtn {
        margin: 0;
        height: auto;
        width: auto;
        margin-right: 10%;
    }
}

.siteForm {
    .category {
        margin-bottom: 10px;
        margin-top: 10px;
        font-size: 20px;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.8);
    }
    .el-form-item__label {
        margin: 0 !important;
    }
    label {
        padding-bottom: 0 !important;
        color: rgba(0, 0, 0, 0.5);
        font-size: 16px;
        margin-top: 20px;
    }
    input {
        border-top: none;
        border-right: none;
        border-left: none;
        border-radius: 0;
    }
    .el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: 100%;
    }
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        input {
            display: none;
        }
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
    .delegate-section {
        padding: 0 20px;
        label {
            margin: 0;
            line-height: 20px;
        }
        .el-input {
            line-height: 30px;
        }
        input {
            height: 30px;
        }
    }
    .naf-code-selector, .operational-mod-selector {
        width: 100%;
        margin: 0;
    }
    .image-error {
        color: #F56C6C;
    }
}
.naf-code-popper {
    right: calc(1em + 12px);
    left: calc(50% + 12px);
    .el-select-group__title {
        font-weight: bold !important;
        font-size: 16px !important;
        color: #555555 !important;
        text-transform: uppercase !important;
    }
}

.el-dialog__headerbtn:focus .el-dialog__close, .el-dialog__headerbtn:hover .el-dialog__close {
    color: @color-1;
}
.el-form-item.is-success .el-input__inner, .el-form-item.is-success .el-input__inner:focus, .el-form-item.is-success .el-textarea__inner, .el-form-item.is-success .el-textarea__inner:focus, .el-input.is-active .el-input__inner, .el-input__inner:focus {
    border-color: @color-1;
}
</style>



// WEBPACK FOOTER //
// src/components/page/site.vue